import dayjs from "dayjs";
import QRCode from "qrcode";
import {
  IPackagePrice,
  IProductCategory,
  IProductSlotPrice,
} from "@/types/db/product-category";
import { getProductCategoryByPriceId } from "@/dexie/product-category";
import POSConfigModule from "@/store/modules/pos-config";
import { getBackOfficeBaseUrl } from "../helpers/common";
import { generateQRCodeContent, OrderLinePublicType } from "@smeetz/orders";
import { ITimeSlot } from "@/types/db/timeslots";
import { queryTimeslotsByProductCategories } from "@/dexie/timeslots";

/**
 * Returns the gift card's own validity timeslot. Used when a gift card is sold
 * as an add-on (ORD-582), where the parent ticket's timeslot window does not
 * apply — the gift card has its own validity period instead.
 */
export async function getGiftCardAddonTimeslot(
  addonPC: IProductCategory
): Promise<ITimeSlot | undefined> {
  const timeslots = await queryTimeslotsByProductCategories({
    categoryIds: [addonPC.id],
    endDateTimeAfter: dayjs().toISOString(),
  });
  return timeslots?.[0];
}

/**
 * returns an array of type IPackagePrice with non-automatic addons related to the given price
 * @param price: IPSP
 */
export async function getPriceNonAutomaticAddons(
  price: IProductSlotPrice | null
): Promise<IPackagePrice[]> {
  const pssAddons: IPackagePrice[] = [];
  if (!price) {
    return pssAddons;
  }
  for (const addon of price.addons) {
    if (addon.canceled === 1 || addon.automaticallyBook === 1) {
      continue;
    }
    const addonPC = await getProductCategoryByPriceId(addon.priceId);
    if (!addonPC) {
      console.log("addon: PC not found", addon.priceId);
      continue;
    }
    const matchedPrice = addonPC.prices.find((p) => p.id === addon.priceId);
    if (!matchedPrice) {
      console.log("addon: price not found in PC", addon.priceId);
      continue;
    }
    pssAddons.push({ ...addon, priceUuid: matchedPrice.uuid });
  }
  return pssAddons;
}

export async function getTicketQRCode(
  token: string,
  itemType: OrderLinePublicType,
  voucherCode?: string
): Promise<string> {
  const qrcodeString = generateQRCodeContent({
    token,
    itemType,
    voucherCode,
    oneTokenVoucherTickets:
      POSConfigModule.groupInfo?.oneTokenVoucherTickets === 1,
    backOfficeBaseUrl: getBackOfficeBaseUrl(),
  });
  return await QRCode.toDataURL(qrcodeString, { margin: 0 });
}
